import QrScanner from 'qr-scanner';
import React, { useEffect, useRef, useState } from 'react';

import { useGetLibraryConstantsDictionary } from '../../../hooks/use-get-library-constants-dictionary';

interface ScanQRCodeProps {
  onScanned: (value: string) => void;
  onClose: () => void;
  node_locale: string;
}

export const ScanQRCode = ({
  onScanned,
  onClose,
  node_locale,
}: ScanQRCodeProps) => {
  const dictionary = useGetLibraryConstantsDictionary(node_locale);
  const videoRef = useRef<HTMLVideoElement | null>(null);
  const [scanner, setScanner] = useState<QrScanner | null>(null);

  useEffect(() => {
    if (!videoRef.current) return;

    const qrScanner = new QrScanner(
      videoRef.current,
      (result) => {
        onScanned(result.data);
        qrScanner.stop();
        setScanner(null);
      },
      {
        preferredCamera: 'environment',
        highlightScanRegion: false,
        highlightCodeOutline: false,
      },
    );
    qrScanner.setInversionMode('both');

    qrScanner
      .start()
      .then(() => setScanner(qrScanner))
      .catch((err) => {
        if (err === 'Camera not found.') {
          onScanned('CAMERA_PERMISSION_DENIED');
        } else {
          // eslint-disable-next-line no-console
          console.error('QR Scanner error:', err);
        }
      });

    return () => {
      qrScanner.stop();
    };
  }, []);

  return (
    <div className="fixed inset-0 z-[9999] bg-black flex items-center justify-center">
      <video
        ref={videoRef}
        className="w-full h-full object-cover"
        playsInline
        muted
      />
      <button
        onClick={() => {
          scanner?.stop();
          onClose();
        }}
        className="absolute top-8 z-50 rounded-full text-text-inverse left-8 lg:left-auto lg:w-12 lg:h-12 lg:right-8 lg:bg-background-primary lg:text-neutral-grey-400"
      >
        ✕
      </button>
      <div className="absolute top-20 text-text-inverse text-center lg:text-headingl lg:font-title text-headingm font-sans">
        {dictionary?.qrCodeScanTitleText ?? 'Scan QR Code'}
      </div>
      <div className="absolute h-[30%] w-[64%] lg:w-[15%] border-[5px] rounded-[5px] border-brand-white"></div>
      <div className="absolute bottom-16 text-center w-[80%] text-text-inverse font-sans">
        {dictionary?.qrCodeScanInfoText ??
          'Align the QR code inside the frame to scan'}
      </div>
    </div>
  );
};
